$.fn.search = function(options) {
  var self = this;

  var options = options || {};

  var search = $(this);

  var ITEM_CUTOFF = 4;
  var input = search.find('input[name=igusername]');
  var menu = search.find('.input-search-dropdown-menu');
  var selection = search.find('.input-search-selection');
  var template = search.find('.input-search-item-template');
  var loading = search.find('.loading');
  
  var debounce;
  if (typeof options.onInput === 'function') {
    debounce = avDebounce(function(auto) {
      var value = input.val();
      if (!value) {
        menu.empty();
        return;
      }

      options.onInput.call(self, value, auto);
    }, 500);

    input.on('input.input-search', function() {
      debounce();
    });
  }

  selection.find('.close').on('click.input-search', function(e) {
    e.preventDefault();

    input.prop('disabled', false);
    input.focus();
    search.removeClass('selected');

    debounce();
  });

  self.createItem = function() {
    return template.children().clone();
  }

  self.loading = function(isLoading) {
    if (typeof isLoading !== 'boolean') {
      return loading.is(':visible');
    }

    loading[isLoading ? 'show' : 'hide']();
  };
  self.loading(false);

  self.isSelected = function() {
    return search.hasClass('selected');
  };

  self.showAll = function(show) {
    menu[show ? 'addClass' : 'removeClass']('show-all');
  };

  self.bindItems = function(items) {
    menu.empty();
    self.showAll(false);

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      menu.append($('<li></li>').append(item));
    }

    menu.find('.input-search-item').on('click.input-search', function(e) {
      e.preventDefault();

      self.bindSelection($(this));
    });

    if (items.length > ITEM_CUTOFF) {
      // Show load more option if more than minimum items
      menu.append($('<li class="load-more"><a href="#">Load more</a></li>'));
      menu.find('.load-more > a').on('click.load-more', function(e) {
        e.preventDefault();

        self.showAll(true);
      });
    } else {
      self.showAll(true);
    }
  };

  self.bindSelection = function(item) {
    var value = item.data('value');
    self.val(value);

    selection.children().not('.close').remove();
    selection.prepend(
      item.children().clone()
    );

    input.prop('disabled', true);
    input.trigger('change');
    search.addClass('selected');
  };

  self.val = function() {
    return input.val.apply(input, arguments);
  };

  if (!self.isSelected() && self.val()) {
    debounce(true);
  }

  return self;
};